module.exports = __webpack_public_path__ + "static/media/main idea.edc34ee8.mp3";